/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProfileFormMetafieldType = {
    Boolean: 'boolean',
    Date: 'date',
    ListSingleLineTextField: 'list.single_line_text_field',
    MultiLineTextField: 'multi_line_text_field',
    NumberDecimal: 'number_decimal',
    NumberInteger: 'number_integer',
    SingleLineTextField: 'single_line_text_field'
} as const;
export type ProfileFormMetafieldType = typeof ProfileFormMetafieldType[keyof typeof ProfileFormMetafieldType];

